import React, { createRef, useEffect } from 'react';
import { inject, observer } from 'mobx-react';
import StatusIcon from '../../icons/statusIcon';
import styles from './deliveryTime.scss';
import ModalWrapper from '../../modalwrapper/modalWrapper';
import { IInjectedProps } from '../../../types';
import classNames from 'classnames';
import TabNavigationHelper from '../../../helpers/tabNavigationHelper';

export enum AvailabilityState {
    InStock,
    SoonInStock,
}
const buttonRef = createRef<HTMLElement>();
const DeliveryTime = inject('store')(
    observer(({ store }: IInjectedProps) => {
        const tabNavigation = TabNavigationHelper.instance;
        const [modalOpen, setModalOpen] = React.useState(false);

        useEffect(() => {
            tabNavigation.setFocusAtt(buttonRef.current);
        }, [buttonRef])

        const isDeliveryTimeClickable = !store?.isGlobal && !store?.getHasObsoleteBricks;

        const handleDeliveryTimeClick = React.useCallback((open) => {
            setModalOpen(open);
            if (open) {
                store?.scrollLock.lock();
                store?.hideEsAppButton()
            } else {
                store?.scrollLock.unlock();
                store?.showEsAppButton();
            }
            
            if (!open) {
                if (buttonRef.current)
                    window.shell.tabNav.focus(buttonRef.current);
            }
        }, []);

        const label = store?.getHasObsoleteBricks ? store?.localization.generalL10n.articleNotAvailable
            : store?.orderModuleStore.deliveryTimeString;

        return (
            <div className={classNames(styles.delivery_time_container, styles.full_width)} title={label}>
                <StatusIcon statusColor={
                    store?.getHasObsoleteBricks ? store?.orderModuleStore.soldOutArticleStatusColor
                        : store?.orderModuleStore.deliveryTimeStatusColor} />
                <span
                    data-testid='delivery_time'
                    className={classNames(styles.delivery_time_text, { [styles.clickable]: isDeliveryTimeClickable })}
                    onClick={isDeliveryTimeClickable ? () => handleDeliveryTimeClick(true) : undefined}
                    ref={buttonRef}>
                    {label}
                </span>
                <ModalWrapper
                    isOpen={modalOpen}
                    title={store!.localization.generalL10n.deliveryTime}
                    onClose={() => handleDeliveryTimeClick(false)}
                    content={
                        <div
                            className={styles.delivery_time_modal_content}
                            dangerouslySetInnerHTML={{ __html: store?.localization.generalL10n.deliveryTimeText || '' }}
                        />
                    }
                />
            </div>
        );
    })
);

export default DeliveryTime;
